<template>
  <div id="noLogin">
    <div class="header">
      <img v-bind:src="imgUrl" alt class="bg">
      <div class="top dl_center">
        <div class="title dl_margin2_top">{{$t('云端钱包')}}</div>
        <!-- <ul class="title dl_margin2_top">
          <li
            v-for="(item,index) in list"
            @click="toggle(index)"
            :class="{ 'is_active':index==active}"
            :key="index"
          >{{$t(item)}}</li>
        </ul> -->
      <router-link class="lang" to="/setlanguage">
        <svg t="1640658195311" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3507" width="24" height="24"><path d="M848.804 805.57c70.999-81.259 109.778-184.212 109.778-293.14 0-119.204-46.418-231.275-130.714-315.566C744.873 113.869 634.936 67.62 517.786 66.217c-1.926-0.6-10.292-0.594-12.232 0.015-116.68 1.716-226.125 47.929-308.823 130.632-82.872 82.872-129.106 192.599-130.642 309.555-0.43 1.649-0.435 8.607-0.02 10.225 1.08 117.632 47.365 228.06 130.662 311.362 84.29 84.291 196.362 130.709 315.571 130.709 119.204 0 231.276-46.418 315.571-130.709a460.278 460.278 0 0 0 17.787-18.877 20.541 20.541 0 0 0 1.475-1.439 21.495 21.495 0 0 0 1.669-2.12zM107.448 532.046h187.505c1.32 65.674 9.252 127.263 22.507 182.108-61.69 16.691-100.817 38.374-121.077 51.907-52.07-64.728-84.706-145.705-88.935-234.015z m88.433-272.635c20.09 13.558 59.243 35.461 121.339 52.265-12.995 54.123-20.823 114.775-22.241 179.43H107.525c4.552-87.373 36.91-167.49 88.356-231.695zM917.079 491.1H729.631c-1.413-64.63-9.242-125.26-22.231-179.374 61.957-16.691 101.232-38.446 121.564-52.02 51.307 64.154 83.574 144.16 88.115 231.394z m-228.398 0H532.173V335.058c52.203-1.096 97.1-6.451 135.27-14.034 12.56 52.142 19.84 109.87 21.238 170.076zM532.168 294.113V109.921c36.838 10.399 72.78 49.203 100.925 110.014 8.812 19.036 16.645 39.639 23.465 61.522-35.026 6.768-76.298 11.607-124.39 12.656z m-40.945-183.838v183.802c-47.503-1.126-88.381-6-123.12-12.805 6.804-21.81 14.617-42.357 23.408-61.342 27.843-60.14 63.299-98.755 99.712-109.655z m0 224.768V491.1H335.928c1.388-60.216 8.679-117.954 21.243-170.102 37.837 7.537 82.314 12.887 134.052 14.045z m-155.33 197.002h155.33v158.663c-51.61 1.193-96.02 6.564-133.821 14.106-12.826-52.884-20.209-111.57-21.51-172.77z m155.33 199.623V914.58c-36.413-10.9-71.875-49.515-99.712-109.66-8.678-18.75-16.41-39.03-23.158-60.549 34.642-6.727 75.418-11.55 122.87-12.703z m40.945 183.27V731.608c47.897 1.024 89.098 5.862 124.114 12.657-6.754 21.555-14.495 41.876-23.189 60.656-28.145 60.81-64.082 99.62-100.925 110.019z m0-224.276V532.05h156.544c-1.3 61.097-8.658 119.685-21.443 172.498-38.113-7.532-82.949-12.836-135.101-13.886zM729.66 532.045h187.5c-4.219 88.135-36.73 168.975-88.622 233.636-20.47-13.67-59.633-35.303-121.303-51.871 13.204-54.758 21.104-116.224 22.425-181.765z m71.86-303.304c-18.33 11.571-52.311 29.358-104.858 43.495-19.297-63.053-46.11-115-78.06-150.974 70.395 19.149 133.233 56.837 182.918 107.48zM406.006 121.262c-31.903 35.922-58.69 87.772-77.978 150.702-52.403-14.244-86.37-32.102-104.581-43.586 49.628-50.463 112.333-88.013 182.559-107.116zM223.918 796.964c18.284-11.536 52.096-29.235 104.33-43.336 19.272 62.602 45.973 114.186 77.758 149.965-70.006-19.041-132.531-56.412-182.088-106.63z m394.68 106.629c31.8-35.804 58.517-87.424 77.789-150.083 51.983 14.024 85.975 31.632 104.535 43.203-49.593 50.345-112.2 87.808-182.324 106.88z" p-id="3508" fill="#ffffff"></path></svg>
      </router-link>
      </div>
    </div>
    <div class="content" style="display: block;">
      <div class="main1">
        <p class="wx_fontSize4 title_wallet">{{$t('云端钱包')}}</p>
        <div class="top_main">
          <img src="../assets/img/login_ico_anquan_yunduan.png" alt>
          <span class="wx_fontSize2">{{$t('世界顶尖安全保护')}}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_zichan_yunduan.png" alt>
          <span class="wx_fontSize2">{{$t('独有资产增益，注册存币坐享收益')}}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_daibi_yunduan.png" alt>
          <span class="wx_fontSize2">{{$t('支持超过30+主流币和500+代币')}}</span>
        </div>
      </div>
      <div class="button">
        <div class="resgiter wx_lf" @click="register()">
          <div class="zhuce-btn bg-blue">{{$t('注册')}}</div>
        </div>
        <div class="login wx_rt" @click="login()">
          <div class="zhuce-btn bg-blue">{{$t('登录')}}</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="main1">
        <p class="wx_fontSize4 title_wallet">{{$t('HD钱包')}}</p>
        <div class="top_main">
          <img src="../assets/img/login_ico_siyao_bendi.png" alt>
          <span class="wx_fontSize2">{{$t('100%掌管私钥，资产更放心')}}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_daoru_bendi.png" alt>
          <span class="wx_fontSize2">{{$t('一键导入助记词，方便好用')}}</span>
        </div>
        <div class="top_main">
          <img src="../assets/img/login_ico_daibi_bendi.png" alt>
          <span class="wx_fontSize2">{{$t('支持超过30+主流币和500+代币')}}</span>
        </div>
      </div>
      <div class="button">
        <div class="resgiter wx_lf" @click="register()">
          <div class="zhuce-btn bg-blue2">{{$t('注册')}}</div>
        </div>
        <div class="login wx_rt" :title="$t('世界顶尖安全保护')" @click="login()">
          <div class="zhuce-btn bg-blue2">{{$t('登录')}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { validateEmpty } from "@/utils/validate";
import { Toast } from "mint-ui";
export default {
  data: function() {
    return {
      kefuurl:this.$store.state.initInfo.system_customer_service,
      list: ["云端钱包", "HD钱包"],
      active: 0,
      imgUrl: require("../assets/img/login_bg_yunduan.png")
    };
  },
  activated() {
    this.token = this.$store.getters.token;
    if(!validateEmpty(this.token)){
      this.$router.replace('/index/home')
    }
  },
  methods: {
    toggle(index) {
      this.active = index;
      var tabCardCollection = document.querySelectorAll(".content"),
        len = tabCardCollection.length;
      for (var i = 0; i < len; i++) {
        tabCardCollection[i].style.display = "none";
      }
      tabCardCollection[index].style.display = "block";
      if (index == 0) {
        document.querySelector(".cata").style.display = "block";
        this.isShow = false;
        this.imgUrl = require("../assets/img/login_bg_yunduan.png");
      } else if (index == 1) {
        document.querySelector(".cata").style.display = "none";
        this.show = false;
        this.imgUrl = require("../assets/img/login_bg_bendi.png");
      }
    },
    register() {
      this.$router.push("/register");
    },
    login() {
      this.$router.push("/login");
    }
  }
};

</script>

<style scoped>
#noLogin {
  position: relative;
  width: 100%;
  background: #f6f6f6;
  height: 100%;
  z-index: 1000;
}
/*顶部*/
.header {
  width: 100%;
  height: 200px;
}
.header .bg {
  width: 100%;
  height: 100%;
}
.top {
  width: 100%;
  height: 48px;
  position: absolute;
  top: 0;
}
.file {
  width: 20px;
  height: 20px;
  margin-left: 15px;
}
.cata {
  width: 20px;
  height: 20px;
  margin-right: 15px;
}
.title {
  width: calc(100% - 114px);
  height: 28px;
  color: #fff;
  border: 1px solid transparent;
  border-radius: 5px;
  position: absolute;
  left: 57px;
}
.title li {
  width: 50%;
  height: 100%;
  float: left;
  color: #fff;
  font-size: 14px;
  text-align: center;
  line-height: 28px;
}
.title .is_active {
  background: #fff;
  color: #0191f5;
}
/*内容*/
.content {
  background: #f6f6f6;
  width: 80%;
  display: none;
  padding: 0 10%;
  z-index: 1000;
}
.main1 {
  width: 100%;
  margin-top: 25px;
  box-shadow: 0 0 20px rgba(0, 119, 255, 0.2);
  background: #fff;
  padding-bottom: 20px;
  padding: 10px;
    box-sizing: border-box;
}
.button {
  width: 100%;
  position: relative;
  height: 56px;
  margin-top: 25px;
}
.resgiter,
.login {
  width: 46%;
}
.resgiter {
  margin-right: 2%;
}
.login {
  margin-left: 2%;
}
.resgiter img,
.login img {
  width: 100%;
  height: 56px;
}
.title_wallet {
  width: 100%;
  text-align: center;
  color: #212529;
}
.top_main {
  padding: 10px;
}
.top_main img {
  width: 20px;
  height: 20px;
}
.top_main span {
  color: #8c92a8;
  position: relative;
  top: -5px;
  margin-left: 10px;
}
.zhuce-btn{
  width:100%;
  height:40px;
  line-height:40px;
  text-align:center;
  color:#fff;
}
.bg-blue{
   background-color:#1980D6; 
}
.bg-blue2{
   background-color:#5351f1; 
}
.lang {
  position: absolute;
  top: 12px;right: 15px;
}
</style>
